/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_O2Inputs */

const en_mk_sol_lembaga_o2 = /** @type {(inputs: Mk_Sol_Lembaga_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting material accumulates along the way instead of being chased at the end`)
};

const id_mk_sol_lembaga_o2 = /** @type {(inputs: Mk_Sol_Lembaga_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahan laporan terkumpul sepanjang jalan, bukan dikejar di akhir`)
};

/**
* | output |
* | --- |
* | "Reporting material accumulates along the way instead of being chased at the end" |
*
* @param {Mk_Sol_Lembaga_O2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_o2 = /** @type {((inputs?: Mk_Sol_Lembaga_O2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_O2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_o2(inputs)
	return en_mk_sol_lembaga_o2(inputs)
});